export class Visa {
	constructor() {
		this.ajax = window.ajax;
	}

	checkVisaSimple(parent) {
		// Validate form before submitting
		if (!window.crm.validateForm(parent)) {
			console.log('[Visa] Валидация формы не прошла');
			return false;
		}

		let form = $(parent);

		// Find the closest answer wrapper
		let answerWrapper = form.closest('.visa-check__container').find('.visa-check__answer-wrapper');

		this.ajax.post('/ajax.php?mid=17', {
			action: 'checkVisaSimple',
			...Object.fromEntries(new FormData(parent))
		}, {
			dataType: 'html'
		}).then(html => {
			answerWrapper.html(html);
			answerWrapper.slideDown();
		}).catch(error => {
			console.error('Error checking visa:', error);
			alert('Ошибка! Попробуйте повторить запрос.');
		});
	}

	checkVisaComplex(parent) {
		// Validate form before submitting
		if (!window.crm.validateForm(parent)) {
			console.log('[Visa] Валидация формы не прошла');
			return false;
		}

		let form = $(parent);

		// Find the closest answer wrapper
		let answerWrapper = form.closest('.visa-check__container').find('.visa-check__answer-wrapper');

		// Get datepicker values from hidden inputs
		const inDatepicker = form.find('.datepicker').first();
		const outDatepicker = form.find('.datepicker').last();

		const inDate = inDatepicker.find('.datepicker__value').val();
		const outDate = outDatepicker.find('.datepicker__value').val();

		// Get form data
		let formData = Object.fromEntries(new FormData(parent));

		// Add dates
		if (inDate) formData.in_date = inDate;
		if (outDate) formData.out_date = outDate;

		this.ajax.post('/ajax.php?mid=17', {
			action: 'checkVisaComplex',
			...formData
		}, {
			dataType: 'html'
		}).then(html => {
			answerWrapper.html(html);
			answerWrapper.slideDown();
		}).catch(error => {
			console.error('Error checking visa:', error);
			alert('Ошибка! Попробуйте повторить запрос.');
		});
	}

	checkVisaVFTF(parent) {
		// Validate form before submitting
		if (!window.crm.validateForm(parent)) {
			console.log('[Visa] Валидация формы не прошла');
			return false;
		}

		let form = $(parent);

		// Find the closest answer wrapper
		let answerWrapper = form.closest('.visa-check__container').find('.visa-check__answer-wrapper');

		// Get datepicker values from hidden inputs
		const inDatepicker = form.find('.datepicker').first();
		const outDatepicker = form.find('.datepicker').last();

		const inDate = inDatepicker.find('.datepicker__value').val();
		const outDate = outDatepicker.find('.datepicker__value').val();

		// Get form data
		let formData = Object.fromEntries(new FormData(parent));

		// Add dates
		if (inDate) formData.in_date = inDate;
		if (outDate) formData.out_date = outDate;

		this.ajax.post('/ajax.php?mid=17', {
			action: 'checkVisaVFTF',
			...formData
		}, {
			dataType: 'html'
		}).then(html => {
			answerWrapper.html(html);
			answerWrapper.slideDown();
		}).catch(error => {
			console.error('Error checking visa:', error);
			alert('Ошибка! Попробуйте повторить запрос.');
		});
	}
}
